import React from "react";
import "../styles/about.css";

export default function About() {
  const experiences = [
    {
      logo: "/assets/Ody.png",
      role: "Trainee Engineer",
      company: "Odyssey Technologies Limited",
      duration: "Jan 2026 – Present",
      location: "Mumbai, Maharashtra · On-site"
    },
    {
      logo: "/assets/hashedbit.jpg",
      role: "Full Stack Developer Intern",
      company: "HashedBit Innovations",
      duration: "Dec 2024 – Jun 2025",
      location: "Remote"
    }
  ];

  return (
    <section id="about" className="about-section">
      <h1 className="about-section-title">Get To Know More About Me</h1>

      <div className="about-containers">

        <div className="details-container">
          <div className="section-header">
            <h3>Experience</h3>
          </div>

          {experiences.map((exp, index) => (
            <div key={index} className="experience-item">
              <img src={exp.logo} alt="company logo" className="company-logo" />
              <div className="experience-info">
                <h4>{exp.role}</h4>
                <p className="company-name">{exp.company}</p>
                <span className="duration">{exp.duration}</span>
                <span className="location">{exp.location}</span>
              </div>
            </div>
          ))}

        </div>

        <div className="details-container">
          <div className="section-header">
            <h3>Education</h3>
          </div>

          <div className="education-item">
            <img className="college-logo" src="/assets/logo1.jpg" alt="GCOEY" />
            <div className="college-info">
              <h4>Government College of Engineering, Yavatmal</h4>
              <p>B.Tech in Computer Engineering</p>
              <span className="percentage">CGPA 8.00 • Nov 2022 – June 2025</span>
            </div>
          </div>

          <div className="education-item">
            <img className="college-logo" src="/assets/logo2.jpg" alt="GPN" />
            <div className="college-info">
              <h4>Government Polytechnic, Nanded</h4>
              <p>Diploma</p>
              <span className="percentage">87.44% • Aug 2019 – Aug 2022</span>
            </div>
          </div>

          <div className="education-item">
            <img className="college-logo" src="/assets/ssc.jpg" alt="VVHS" />
            <div className="college-info">
              <h4>Vivek Vardhini Highschool, Basmath</h4>
              <p>SSC (10th)</p>
              <span className="percentage">85.60% • June 2018 – March 2019</span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}